import { useLang, LANGUAGES } from "../context/LangContext";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "./ui/dropdown-menu";

export default function LanguagePicker() {
  const { lang, chooseLang } = useLang();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-picker"
          className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-black/15 bg-white text-xs font-bold hover:border-[color:var(--primary)] transition-colors"
          aria-label="Change language"
        >
          <Globe className="w-3.5 h-3.5" />
          <span>{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => chooseLang(l.code)}
            className={l.code === lang ? "font-bold text-[color:var(--secondary)]" : ""}
          >
            <Globe className="w-3.5 h-3.5 mr-2" /> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
